import { useEffect, useState } from 'react';
import { useGetContactCustomFieldsApi } from 'src/api/customFields';
import { ContactDefaultCustomField } from 'src/constants/types';
import { getErrorMessage } from '../../helpers';

/** Every contact custom field of the company, offered as a source for extra form fields. */
export const useContactCaptureCustomFieldOptions = (companyId?: string) => {
  const getCustomFields = useGetContactCustomFieldsApi();
  const [customFieldOptions, setCustomFieldOptions] = useState<ContactDefaultCustomField[]>([]);
  const [customFieldsLoading, setCustomFieldsLoading] = useState(false);
  const [customFieldsError, setCustomFieldsError] = useState<string | null>(null);

  useEffect(() => {
    if (!companyId) {
      setCustomFieldOptions([]);
      return;
    }

    let active = true;
    const loadCustomFields = async () => {
      setCustomFieldsLoading(true);
      setCustomFieldsError(null);
      try {
        const response = await getCustomFields({
          companyId,
          customOnly: true,
          sort: 'description_asc',
        });
        if (!active) return;
        setCustomFieldOptions(response.data.items.filter(item => Boolean(item.metadataId)));
      } catch (error) {
        if (active) setCustomFieldsError(getErrorMessage(error, 'Could not load custom fields.'));
      } finally {
        if (active) setCustomFieldsLoading(false);
      }
    };

    void loadCustomFields();
    return () => { active = false; };
  }, [companyId, getCustomFields]);

  return { customFieldOptions, customFieldsError, customFieldsLoading };
};
